'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'desktop';
var width = 512;
var height = 512;
var aliases = [128421,61704,"desktop-alt"];
var unicode = 'f390';
var svgPathData = ['M16 96l0 224 480 0 0-224c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96zM193.4 496l125.1 0-13.3-80-98.4 0-13.3 80z', 'M448 48c26.5 0 48 21.5 48 48l0 224-480 0 0-224c0-26.5 21.5-48 48-48l384 0zm48 288l0 16c0 26.5-21.5 48-48 48L64 400c-26.5 0-48-21.5-48-48l0-16 480 0zM64 416l126.6 0-13.3 80-73.2 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l304 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-73.2 0-13.3-80 126.6 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 352c0 35.3 28.7 64 64 64zm129.4 80l13.3-80 98.4 0 13.3 80-125.1 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDesktop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;